import { useState } from "react";

import "./styles/info-step.css";

export default function InfoStep({ data, onChange, onBack, onNext }) {
  const [error, setError] = useState("");

  const bind = (k) => (e) => onChange({ [k]: e.target.value });

  const handleNext = () => {
    const req = [
      "gifterName",
      "gifterEmail",
      "recipientName",
      "recipientEmail",
    ];
    if (
      req.some((k) => !data[k]) ||
      !data.gifterEmail.includes("@") ||
      !data.recipientEmail.includes("@")
    ) {
      setError("Please complete all required fields with valid emails.");
      return;
    }
    setError("");
    onNext();
  };

  return (
    <section className="step step--wide info-step step--top fade-in">
      <h2>Gift Details</h2>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleNext();
        }}
      >
        <div className="info-grid">
          <fieldset>
            <legend>Your info</legend>
            <label>
              Full Name
              <input value={data.gifterName} onChange={bind("gifterName")} />
            </label>
            <label>
              Email
              <input
                type="email"
                value={data.gifterEmail}
                onChange={bind("gifterEmail")}
              />
            </label>
          </fieldset>

          <fieldset>
            <legend>Recipient info</legend>
            <label>
              Full Name
              <input
                value={data.recipientName}
                onChange={bind("recipientName")}
              />
            </label>
            <label>
              Email
              <input
                type="email"
                value={data.recipientEmail}
                onChange={bind("recipientEmail")}
              />
            </label>
          </fieldset>

          <label className="textarea-row">
            Personal Message (optional)
            <textarea rows={3} value={data.note} onChange={bind("note")} />
          </label>
        </div>

        {error && <p className="form-error">{error}</p>}

        <div className="actions">
          <button type="button" className="secondary-btn" onClick={onBack}>
            Back
          </button>
          <button type="submit" className="primary-btn">
            Preview Gift →
          </button>
        </div>
      </form>
    </section>
  );
}
